import { Component, OnInit, ViewChild, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { HechoIrregularComponent } from '../hecho-irregular/hecho-irregular.component';
import { EntidadHechoComponent } from '../entidad-hecho/entidad-hecho.component';
import { PruebaHechoComponent } from '../prueba-hecho/prueba-hecho.component';
import { Fur } from 'src/app/models/Fur';
import { MdenunciaContenedorC } from 'src/app/models/personalizados/MdenunciaContenedorC';
import { InstanciaComponent } from '../instancia/instancia.component';
import { DscMensajeSpinner, iconAgregar } from 'src/app/general/variables';
import { MatDialog } from '@angular/material';
import { ModalEncuestaComponent } from '../../Denunciante/modal-encuesta/modal-encuesta.component';
import { Denunciante } from 'src/app/models/Denunciante';
import { General } from 'src/app/models/General';
import { Entidad } from 'src/app/models/Entidad';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-denuncia-contenedor',
  templateUrl: './denuncia-contenedor.component.html',
  styleUrls: ['./denuncia-contenedor.component.css'],
  encapsulation: ViewEncapsulation.None

})
export class DenunciaContenedorComponent implements OnInit {

  @ViewChild(HechoIrregularComponent) hechoIrregularC: HechoIrregularComponent;
  @ViewChild(EntidadHechoComponent) entidadHechoC: EntidadHechoComponent;
  @ViewChild(PruebaHechoComponent) pruebaHechoC: PruebaHechoComponent;
  @ViewChild(InstanciaComponent) instanciaC: InstanciaComponent;

  requireIdentificarse =  false;
  @Output()  activaDenuncianteEmitter = new EventEmitter();

 require_identificarse = false;
 flgLectura = false;
 iconAgregar = iconAgregar;
 // CUS04
 flgEsFur = false;
 denuncianteAnonimo: Denunciante = null;
 flgExisteDenunciante = false;
 DscMensajeSpinner: String = DscMensajeSpinner;
 strDscToolTip1 = 'El contenido de la denuncia y la identidad del denunciante se encuentran protegidos por el principio de reserva desde su recepción, de acuerdo con lo establecido en el literal n) del artículo 9° de la Ley N° 27785. Si no se identifica su denuncia se tratará como “Anónima”. Solo en el caso de identificarse podrá recibir notificaciones y registrar el Formato de Solicitud de Medidas de Protección y Beneficios.';

  constructor(public dialog: MatDialog,
              private spinner: NgxSpinnerService) { }

  ngOnInit() {

  }

  obtenerDatosHijo(tipoHecho) {

  }

  _cambioCheckReqIden(cbkRequiereIden) {

    this._emitirCambio(cbkRequiereIden, false, false, true);

  }

  _emitirCambio(cbkRequiereIden, flgSeteo: boolean, flgRecupBorrador: boolean, flgCheckManual: boolean) {

    const vGeneral: General = new General();

    this.requireIdentificarse = cbkRequiereIden;

    vGeneral.flgCampo1 = this.requireIdentificarse;
    vGeneral.flgCampo2 = flgSeteo; // SETEO
    vGeneral.flgCampo3 = flgRecupBorrador; // SI RECUPERA BORRADOR
    vGeneral.flgCampo4 = flgCheckManual; // SI RECUPERA BORRADOR
    vGeneral.flgCampo5 = this.flgExisteDenunciante;

    // console.log("============FUR 2", this.)

    this.activaDenuncianteEmitter.emit(vGeneral);

  }



  ConsultarDenuncia(mDenunciaContenedorC: MdenunciaContenedorC) {

    // console.log("================mDenunciaContenedorC");
    // console.log(mDenunciaContenedorC);

    this.entidadHechoC.ConsultarEntidadHecho(mDenunciaContenedorC.mEntidadHechoC);


  }

  _abrirModalEncuesta() {

    const dialogRef = this.dialog.open(ModalEncuestaComponent, { width: '75%', height: '60%',
    data: this.denuncianteAnonimo});

    dialogRef.afterClosed().subscribe(result => {

      if (result != null) {

        this.denuncianteAnonimo = result;

      }

    });

  }

  _entidadOut(data: Entidad) {

    this.hechoIrregularC.setEntidadHecho(data);

  }

  denunciaContenedorCReadEnable() {
    this.flgLectura = true;
  }

  denunciaContenedorCReadDisable() {
    this.flgLectura = false;
  }

  setDenunciaContenedorC(fur: Fur) {

    let vFlgRecupBorrador = fur.flgRecupBorrador;

    vFlgRecupBorrador = (vFlgRecupBorrador == null ? false : vFlgRecupBorrador);

    this.requireIdentificarse = fur.cfurFlgreqidentif == 'SI' ? true : false;
    this.flgExisteDenunciante = (fur.denunciante ? true : false);


    this._emitirCambio(this.requireIdentificarse, true, vFlgRecupBorrador, false);
  }

  getDenuncianteAnonimo() {

    return this.denuncianteAnonimo;

  }




}
